import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonContainer from '../../components/buttonContainer';
import CollapsibleComponent from '../../components/collapsible';
import EnumerationOptionContainer from '../../components/enumerationOptionContainer';
import Input from '../../components/input';
import TextArea from '../../components/textarea';
import getBudgetOptions from '../../data/budget';
import getRooms from '../../data/rooms';
import getScheduleOptions from '../../data/schedule';

export default function ProjectInformation({
  onClickNextStep,
  onClickPreviousStep,
  onChangeInputProject,
  onChangeInputRoom,
  selectedBudget,
  onClickBudget,
  selectedSchedule,
  onClickSchedule,
  project,
  rooms,
}) {
  const { t } = useTranslation();

  const getRoomTitle = (type) => {
    const roomOptions = getRooms();
    const room = roomOptions.find((option) => option.type === type);
    return room ? room.name : type;
  };

  const handleChangeInputRoom = (event, room) => {
    onChangeInputRoom(event, room);
  };

  return (
    <div className="layout-container project-information">
      <div className="block-container">
        <h3>{t('pages.projectInformation.title')}</h3>
        <div className="subtitle">{t('pages.projectInformation.subtitle')}</div>
        <div className="project-information__about-container">
          <CollapsibleComponent title={t('pages.projectInformation.about.title')}>
            <div className="project-information__about-content">
              <ul>
                <li>{t('pages.projectInformation.about.firstItem')}</li>
                <li>{t('pages.projectInformation.about.secondItem')}</li>
                <li>{t('pages.projectInformation.about.thirdItem')}</li>
                <li>{t('pages.projectInformation.about.fourthItem')}</li>
              </ul>
              <div>{t('pages.projectInformation.about.description')}</div>
            </div>
          </CollapsibleComponent>
        </div>
        <div className="input-block">
          <h4>{t('pages.projectInformation.form.dimensions.title')}</h4>
          {rooms.map((room) => {
            return (
              <div key={room.type}>
                <h5 className="mb-05 mt-1">{getRoomTitle(room.type)}</h5>
                <div className="input-fields">
                  <Input
                    key="length"
                    onChange={(event) => handleChangeInputRoom(event, room)}
                    label={t('pages.projectInformation.form.dimensions.answer.length.label')}
                    name="length"
                    value={room.length || ''}
                    placeholder={t(
                      'pages.projectInformation.form.dimensions.answer.length.placeholder',
                    )}
                    type="number"
                  />
                  <Input
                    key="width"
                    onChange={(event) => handleChangeInputRoom(event, room)}
                    label={t('pages.projectInformation.form.dimensions.answer.width.label')}
                    name="width"
                    value={room.width || ''}
                    placeholder={t(
                      'pages.projectInformation.form.dimensions.answer.width.placeholder',
                    )}
                    type="number"
                  />
                  <Input
                    key="height"
                    onChange={(event) => handleChangeInputRoom(event, room)}
                    label={t('pages.projectInformation.form.dimensions.answer.height.label')}
                    name="height"
                    value={room.height || ''}
                    placeholder={t(
                      'pages.projectInformation.form.dimensions.answer.height.placeholder',
                    )}
                    type="number"
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="input-block">
          <h4>{t('pages.projectInformation.form.budget.title')}</h4>
          <span>{t('pages.projectInformation.form.budget.subtitle')}</span>
          <div className="input-fields">
            <EnumerationOptionContainer
              name="budget"
              options={getBudgetOptions()}
              selectedOption={selectedBudget}
              onClick={onClickBudget}
            />
          </div>
        </div>
        <div className="input-block">
          <h4>{t('pages.projectInformation.form.schedule.title')}</h4>
          <div className="input-fields">
            <EnumerationOptionContainer
              name="schedule"
              options={getScheduleOptions()}
              selectedOption={selectedSchedule}
              onClick={onClickSchedule}
            />
          </div>
        </div>
        <div className="input-block">
          <h4>{t('pages.projectInformation.form.descriptionOfProject.title')}</h4>
          <TextArea
            onChange={onChangeInputProject}
            name="description"
            value={project.description || ''}
            placeholder={t('pages.projectInformation.form.descriptionOfProject.placeholder')}
          />
        </div>
      </div>

      <div className="button-container-wrapper">
        <ButtonContainer
          areFieldsValid={
            rooms.every((room) => room.length && room.width && room.height) &&
            selectedBudget.id &&
            selectedSchedule.id
          }
          hasPreviousStep
          previousButtonOnClick={onClickPreviousStep}
          firstButtonCaption={t('pages.projectInformation.buttons.dontKnowButton')}
          firstButtonOnClick={onClickNextStep}
          secondButtonCaption={t('buttons.nextButton')}
          secondButtonOnClick={onClickNextStep}
          secondButtonType="primary"
          secondButtonIcon="arrowRight"
        />
      </div>
    </div>
  );
}
